import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  actions: {
    loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/departments`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/departments/page/${pagination.facultyId}`, { params: pagination })
    },
    fetchItem ({ commit, dispatch }, payload) {
      console.log('-> fetchItem', payload)
      return Vue.axios.get(`${config.serverURI}/departments/${payload}`)
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/departments`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/departments/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/departments/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/department.js